import styled from 'styled-components';
import { getFont, getBorderRadius } from '@24i/nxg-sdk-higgs/src/StyleSheet';
const PACKSHOT_HEIGHT = 139;
const BORDER_WIDTH = 4;
export const SingleRowContainer = styled.div `
    display: flex;
`;
export const Container = styled.div `
    width: 100%;
    height: fit-content;
    align-items: flex-end;

    & .swiper-container {
        overflow: visible;
    }

    & .swiper-slide:hover {
        z-index: 10;
    }

    & .swiper-button-small {
        height: 19px;
    }
`;
export const PackshotHolder = styled.div `
    transition: transform ease 200ms;
    cursor: pointer;
    &:hover {
        transform: scale(1.1);
    }

    & img {
        border: ${({ isCurrentlyPlaying }) => isCurrentlyPlaying ? '4px solid #fabc0b' : 'none'} !important;
    }
`;
export const getSeasonPickerStyles = (theme) => {
    return {
        viewContainer: {
            flex: 1,
            zIndex: 2147483647,
            width: 'fit-content',
            maxHeight: 42,
            paddingLeft: '5%',
        },
        pickerContainer: Object.assign(Object.assign({ paddingLeft: 7, backgroundColor: theme.color.buttonTertiary }, getBorderRadius(theme.elements, 'buttonTertiary-cornerRadius')), { display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', justifyContent: 'center', alignItems: 'center', width: 'fit-container', minWidth: 122, zIndex: 2147483647, height: 42 }),
        optionsContainer: {
            container: Object.assign(Object.assign({ minHeight: '100px', maxHeight: '140px', overflowY: 'scroll', backgroundColor: theme.color.darker1, borderRadius: 4 }, getBorderRadius(theme.elements, 'generalTile-cornerRadius')), { minWidth: 224, marginTop: 8, paddingTop: 9, paddingBottom: 9, left: 0 }),
            itemContainer: {
                paddingTop: 8.5,
                paddingBottom: 8.5,
                paddingLeft: 16,
                ':hover': {
                    backgroundColor: theme.color.primary4,
                },
            },
            selectedItem: Object.assign(Object.assign({}, getFont(theme, 'body1')), { color: theme.color.textPrimary, opacity: 1 }),
            item: Object.assign(Object.assign({}, getFont(theme, 'body1')), { color: theme.color.textPrimary, opacity: 0.8 }),
        },
        pickerText: Object.assign(Object.assign({ display: 'flex' }, getFont(theme, 'tertiaryButton')), { textAlign: 'center', color: theme.color.darker1, width: 'auto' }),
    };
};
export const getLinearGradientStyles = () => {
    return {
        width: '100%',
        height: PACKSHOT_HEIGHT / 2,
        position: 'absolute',
        bottom: BORDER_WIDTH,
        left: BORDER_WIDTH,
    };
};
//# sourceMappingURL=index.js.map